import { Award, Wine, Wallet, Heart, Users } from "lucide-react";

const WhyChooseUs = () => {
  const features = [
    {
      icon: Award,
      title: "Producto de Calidad",
      description:
        "Seleccionamos cuidadosamente nuestros productos para ofrecer siempre ingredientes de primera calidad.",
    },
    {
      icon: Wine,
      title: "Gran Bodega",
      description:
        "Contamos con una amplia selección de vinos de España y Portugal.",
    },
    {
      icon: Wallet,
      title: "Excelente Relación Calidad-Precio",
      description:
        "Queremos que disfrutes de una gran experiencia gastronómica sin preocuparte por el presupuesto.",
    },
    {
      icon: Heart,
      title: "Servicio Cercano",
      description:
        "Nuestro equipo destaca por su amabilidad, profesionalidad y atención al cliente.",
    },
    {
      icon: Users,
      title: "Ambiente Agradable",
      description:
        "Un espacio acogedor donde disfrutar de la gastronomía y la buena compañía.",
    },
  ];

  return (
    <section className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-accent text-[#800020] text-lg mb-4">
            Nuestra diferencia
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-4">
            Por Qué Nuestros Clientes Repiten
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-8 hover:-translate-y-2 transition-transform duration-500 ease-out"
              data-testid={`feature-${index}`}
            >
              <div className="feature-icon">
                <feature.icon size={28} className="text-[#800020]" />
              </div>
              <h3 className="font-heading text-xl text-[#1A1A1A] mb-3">
                {feature.title}
              </h3>
              <p className="font-body text-[#1A1A1A]/70 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Quote */}
        <div className="mt-16 text-center">
          <blockquote className="font-accent text-2xl text-[#1A1A1A] italic max-w-3xl mx-auto">
            "Nos gusta tratar a nuestros clientes como en casa"
          </blockquote>
          <div className="elegant-divider mt-6">
            <span className="font-body text-sm text-[#800020] uppercase tracking-widest">
              Abacería Como en Casa
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
